import * as React from 'react'
import CheckMarker from '../icons/ui/CheckMarker'
import Select from './Select'

export interface INumberOfRides {
  isOpen: boolean
  onToggle: () => void
  onSetDateData: (dateData: any) => void
  handleSetValue: (key: string, value: any) => void
}

const periud = ['Select', 'Day', 'Week', 'Month']

class NumberOfRides extends React.Component<INumberOfRides, any> {
  constructor(props: INumberOfRides) {
    super(props)
    this.state = {
      value: 1,
      selectedPeriud: 'Select'
    }
  }

  public componentWillMount() {
    this.props.handleSetValue('timeSetting', {
      NumberOfRides: 1,
      periud: 'Select'
    })
  }

  public setPeriud = (periud: string) => {
    const res: any = {
      periud,
      NumberOfRides: this.state.value
    }
    this.setState({ selectedPeriud: res })
    this.props.handleSetValue('timeSetting', res)
  }

  public setRidesCount = (e: any) => {
    if (!isNaN(e.target.value)) {
      const res = {
        periud: this.state.selectedPeriud,
        NumberOfRides: e.target.value
      }
      this.setState({ value: e.target.value })
      this.props.handleSetValue('timeSetting', res)
    }
  }

  public render() {
    return (
      <div className='flex flex-wrap mt2 items-center'>
        <div
          className='border-grey5 bg-white icon--small rounded cursor--pointer justify-center flex'
          onClick={this.props.onToggle}
        >
          {this.props.isOpen && <CheckMarker className='check-marker' />}
        </div>
        <span className='mr1 ml1 h6 font-dark-grey col-10'>Number of rides:</span>
        {this.props.isOpen && (
          <div className='flex items-center ml2 mt2 relative'>
            <div className='border-light-grey4 bg-white rounded col-2'>
              <input
                type='text'
                value={this.state.value}
                onChange={this.setRidesCount}
                className='border-none center border-none h6imp uppercase '
              />
            </div>
            <span className='mr1 ml1 h6 font-dark-grey'>rides per</span>
            <Select selectItems={periud} onSelect={this.setPeriud} />
          </div>
        )}
      </div>
    )
  }
}

export default NumberOfRides



// WEBPACK FOOTER //
// ./src/components/membership-request/NumberOfRides.tsx